import React, { memo } from 'react';
export const ComparisonSection = () => {
  const rows = ['Actividades cognitivas y físicas organizadas por nivel.', 'Registros para ordenar medicación, presión, glucemia, ánimo y sueño.', 'Ideas de socialización y rutinas para compartir en familia.', 'Herramientas para cuidar sin cargar todo sobre una sola persona.'];
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-39">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-40">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold text-center mb-8 md:mb-16 leading-tight" data-id="element-41">
          ¿Cuánto cuesta seguir improvisando el cuidado?
        </h2>
        <p className="text-familia-gray text-[15px] md:text-xl text-center mb-8" data-id="element-42">
          Con Vitalidad 360 podés dejar de buscar actividades sueltas y empezar
          a acompañar con un sistema claro.
        </p>
        <div className="space-y-3 md:space-y-4" data-id="element-43">
          {rows.map((row, i) => <div key={i} className="bg-familia-section border border-familia-green/25 p-4 md:p-6 rounded-2xl flex items-start gap-3 md:gap-4" data-id="element-44">
              <span className="text-familia-green text-xl shrink-0" data-id="element-45">✅</span>
              <p className="text-white/90 text-[15px] md:text-base leading-relaxed" data-id="element-46">
                {row}
              </p>
            </div>)}
        </div>
        <div className="mt-12 md:mt-24 text-center" data-id="element-47">
          <h3 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-4 leading-tight" data-id="element-48">
            La próxima semana podés seguir improvisando o empezar hoy con un
            sistema completo, claro y listo para usar.
          </h3>
        </div>
      </div>
    </section>;
};